export default "__VITE_ASSET__E$vvpPU7__"